module.exports = __webpack_public_path__ + "src/components/DBPagination/left.svg?51627159";


//////////////////
// WEBPACK FOOTER
// ./src/components/DBPagination/left.svg
// module id = 2784
// module chunks = 1